<template>
  <div class="blocked-cards-tooltip">
    <span class="font-medium">{{ label }}</span>
    <CardStatusAndTitle
      v-for="(blockedCard, index) in cards"
      :key="index"
      :title="blockedCard.title"
      :card-id="blockedCard.card_id"
      :status="blockedCard.status || ''"
    />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import CardStatusAndTitle from '@/components/tooltips/CardStatusAndTitle.vue';
import useTranslate from '@/utilities/composables/useTranslate';

const { translate } = useTranslate();

const props = defineProps({
  cards: {
    type: Array,
    required: true,
  },
  relationType: {
    type: String,
    required: true,
  },
});

const label = computed(() => {
  let relationLabel = '';
  switch (props.relationType) {
    case 'blocked_by':
      relationLabel = translate('blockedBy');
      break;
    case 'blocks':
      relationLabel = translate('blocks');
      break;
    default:
      break;
  }
  return `${relationLabel} ${props.cards.length} ${
    props.cards.length > 1 ? translate('cards').toLowerCase() : translate('card').toLowerCase()
  }`;
});
</script>

<style lang="scss">
.blocked-cards-tooltip {
  @apply flex flex-col px-3 py-2 bg-attention-bg rounded-lg text-text-defaultTooltip text-xs;
}
</style>
